import { style } from "@vanilla-extract/css";

export const labelStyle = style({
  overflow: "hidden",
  width: "100%",
  lineHeight: "1 !important",
});

export const labelTextStyle = style({});

export const labelTrailingStyle = style({});
